import { render, staticRenderFns } from "./AccentSettings.vue?vue&type=template&id=079e64ca"
import script from "./AccentSettings.vue?vue&type=script&lang=js"
export * from "./AccentSettings.vue?vue&type=script&lang=js"
import style0 from "./AccentSettings.vue?vue&type=style&index=0&id=079e64ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports